var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "220px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.action === "look",
                  expression: "action==='look'"
                }
              ],
              slot: "left"
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "min-width": "180px",
                    width: "100%",
                    height: "100%",
                    padding: "10px 0px 10px"
                  }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      "min-height": "500px",
                      "padding-left": "16px"
                    },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.gridOptions.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers", staticStyle: { flex: "none" } },
                    [
                      _c("cargo-button-group-slider", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "look",
                                expression: "action==='look'"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "back", type: "primary" },
                                on: { click: _vm.goBack }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                            ),
                            _vm.$checkPermission([
                              "button_FBAWarehousing_editWarehouse"
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { no: "edit", type: "success" },
                                    on: {
                                      click: function($event) {
                                        return _vm.editHandler()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                                )
                              : _vm._e(),
                            _vm.$checkPermission([
                              "button_FBAWarehousing_printWarehouse"
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "print1",
                                      disabled: _vm.isEditing,
                                      type: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onPrintHandler()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isNew || _vm.action === "edit",
                                expression: "(isNew || action==='edit')"
                              }
                            ],
                            staticClass: "new",
                            staticStyle: {
                              "border-left": "none",
                              "padding-left": "0"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isNormal,
                                    expression: "isNormal"
                                  }
                                ],
                                attrs: { no: "onlySave", type: "success" },
                                on: { click: _vm.onlySave }
                              },
                              [_vm._v(_vm._s(_vm.$t("Warehouse.Save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isWeigh,
                                    expression: "isWeigh"
                                  }
                                ],
                                attrs: { no: "weigh", type: "success" },
                                on: { click: _vm.onlyWeigh }
                              },
                              [_vm._v(_vm._s(_vm.$t("Warehouse.Weigh")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isWeigh,
                                    expression: "isWeigh"
                                  }
                                ],
                                attrs: {
                                  no: "weighAndChecklist",
                                  type: "success"
                                },
                                on: { click: _vm.weighAndChecklist }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Warehouse.WeighAndChecklist"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isChecklist,
                                    expression: "isChecklist"
                                  }
                                ],
                                attrs: { no: "checklist", type: "success" },
                                on: { click: _vm.onlyChecklist }
                              },
                              [_vm._v(_vm._s(_vm.$t("Warehouse.Checklist")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { no: "cancel2", type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelEdit()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      !_vm.isEditing &&
                                      _vm.$checkPermission([
                                        "button_FBAWarehousing_printWarehouse"
                                      ]),
                                    expression:
                                      "!isEditing && $checkPermission(['button_FBAWarehousing_printWarehouse'])"
                                  }
                                ],
                                attrs: { no: "print3", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onPrintHandler()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "tabs-container",
                  staticStyle: { position: "relative" }
                },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: { type: "card" },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          key: 1,
                          attrs: {
                            label: _vm.$t("Message.Main"),
                            lazy: true,
                            name: "baseInfo"
                          }
                        },
                        [
                          _c("fba-warehousing-detail", {
                            ref: "baseInfo",
                            attrs: {
                              lob: _vm.lob,
                              action: _vm.action,
                              "warehouse-in-uuid": _vm.currentRow.uuid,
                              "op-type": _vm.opType
                            },
                            on: { success: _vm.onRefresh }
                          })
                        ],
                        1
                      ),
                      !_vm.isNew &&
                      _vm.currentRow.pallet &&
                      _vm.$checkPermission(["tab_FBAWarehousing_playJoeTab"])
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                label: _vm.$t("Warehouse.DaycareInformation"),
                                lazy: true,
                                name: "fbaPallet"
                              }
                            },
                            [
                              _c("fba-pallet", {
                                ref: "fbaPallet",
                                attrs: {
                                  action: _vm.action,
                                  context: _vm.parentContext
                                },
                                on: { success: _vm.onRefresh }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "tab_FBAWarehousing_warehousefileTab"
                      ])
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 3,
                              attrs: {
                                label: _vm.$t("SeaExport.FileHistory"),
                                lazy: true,
                                name: "fileHistory"
                              }
                            },
                            [
                              _c("tab-file-history", {
                                ref: "fileHistory",
                                attrs: { context: _vm.parentContext }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }